<template>
  <div class="ticket-info-page">
    <Steps :active="0"></Steps>

    <Tabs current="ticket"></Tabs>

    <TicketList type="TICKET"></TicketList>

    <TicketList type="BATCH"></TicketList>

  </div>
</template>

<script>
import Steps from '@/components/Steps'
import PageTitle from '@/components/PageTitle'
import TicketList from '@/components/TicketList'

import Tabs from '@/components/Tabs'

export default {
  components: {
    Tabs,
    Steps,
    PageTitle,
    TicketList
  },
  data () {
    return {
      loading: false,
      page: {
        type: 'TICKET',
        pageNum: 1,
        pageSize: 1000
      },
      groupTags: [],
      activeGroup: '',
      normalTicketData: [],
      batchTicketData: [],
      currentItem: {}
    }
  },
  methods: {
    toPage (name) {
      this.$router.push({
        name
      })
    }
  }
}
</script>

<style lang="less">

</style>
